<!-- <router-outlet></router-outlet> -->

<!-- fullscreen -->

<div>
    <router-outlet></router-outlet>
    <div class="fullscreen" *ngIf="fullScreenStatus && false">
        <!-- <div id="myDIV"  class="myclass pb-5 myDIV">
        <img class="circale-rotation-1" src="../assets/images/diwali/Untitled-5.png" alt="">
        <img class="circale-rotation-2" src="../assets/images/diwali/Circle.png" alt="">
        <img class="circale-rotation-3" src="../assets/images/diwali/Untitled-5.png" alt="">
        <img class="circale-rotation-4" src="../assets/images/diwali/Circle2.png" alt="">
        </div> -->
        <div class="fullscreen-icon" (click)="fullScreen(true)">
            <i class="fa fa-expand" aria-hidden="true"></i>
        </div>
        <div class="fullscreen-message">
            <p>TAP TO ENTER FULLSCREEN</p>           
            <p>TAP ANYWHERE ELSE TO CLOSE THIS WINDOW</p>
        </div>
        <!-- <h1 class="happyDiwali ">
            Happy Diwali
        </h1>
        <div class="candle-img pb-5 myDIV pt-3">
            <img src="../assets/images/diwali/Untitled-5 (1).png" alt="">
        </div> -->
        <!-- <div *ngFor="let item of [].constructor(15)" class="bomb-rocket"></div> -->
    </div>
</div>


<!-- <div class="loader" *ngIf="!Data">
    <div class="wrapper">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
    </div>
    <div class="progressbar">
        <div id="myProgress">
            <div id="myBar"></div>
        </div>
    </div>
</div> -->
<!-- <div *ngFor="let item of [].constructor(15)" class="bomb-rocket"></div> -->